import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { logger } from '@core/helpers/logger';

import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';

@Component({
  selector: 'app-homework-mini',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiCoverModule, OnUiButtonModule, OnUiCardMenuModule],
  templateUrl: './homework-mini.component.html',
  styleUrls: ['./homework-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeworkMiniComponent {
  @Input() homework: any;
  @Input() display_mode: string;
  @Output() clicked = new EventEmitter<any>();

  constructor() {}

  onClick(e): void {
    logger.log(e);
  }

  onOpenCardInModal() {}

  onOpenAlert() {}

  onEdit() {}

  public trackByFn(index) {
    return index;
  }
}
